<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeTypeTaxationTlpe.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit" @click="checkPermissions(permsTypeTaxationTlpe.maj)
          ? $router.push({ name: 'm.gabed.type_taxation_tlpe-add'}) : showPopUp()"
               :class="{'button-access-no-permission' :
               !checkPermissions(permsTypeTaxationTlpe.maj) }">
              {{ $t('listeTypeTaxationTlpe.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllTypeTaxationTlpeSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-5">
            <b-input :placeholder="$t('listeTypeTaxationTlpe.actions.search')"
                     type="search" icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                  :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permsTypeTaxationTlpe.exporter"
            :query="exportExcelQuery"/>
        </div>
      </div>
    </div>
    <v-server-table @loaded="finLoading" @loading="debutLoading"
                    :columns="columns" :options="options"
                    class="tableWithChildRow tableWithPerPageSelection"
                    ref="tableTypeTaxationTlpe">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableTypeTaxationTlpe.setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected">
        </b-checkbox>
      </div>
      <div slot="edit" slot-scope="props">
        <div @click="checkPermissions(permsTypeTaxationTlpe.supprimer) ?
        $router.push({ name: 'm.gabed.type_taxation_tlpe-edit',
            params: { id: props.row.id } }) : showPopUp()" class="is-cursor-pointer">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permsTypeTaxationTlpe.maj) }"></b-icon>
        </div>
      </div>
      <div slot="actif" slot-scope="props" class="has-text-centered">
        <b-checkbox class="pointer-events-none" v-model="props.row.actif" type="is-default">
        </b-checkbox>
      </div>
      <div slot="archiver" slot-scope="props">
        <archive-list-button
          :permissions="permsTypeTaxationTlpe.supprimer"
          v-bind="getDataPopupArchivage(props.row)"
          class="has'text-centered"
          @done="recherche()"
          :query="() => archiverTypeTaxationTlpe(props.row)"
          :validation="validationTypeTaxationTlpeArchivage"
          :actif="props.row.actif"/>
      </div>
      <div slot="delete" slot-scope="props">
        <delete-list-button
            :permissions="permsTypeTaxationTlpe.supprimer"
            v-bind="getDataPopupSuppression(props.row)"
            class="has-text-centered"
            @done="recherche()"
            :query="() => supprimerTypeTaxationTlpe(props.row.id)"
            :validation="validationTypeTaxationTlpeSuppression"/>
    </div>
    </v-server-table>
    <b-modal v-model="popUpCreateTypeTaxationLigne" has-modal-card class="modal">
      <pop-up-create-type-taxation-ligne :typesTaxeTlpeSelected="getAllTypeTaxationTlpeSelected()"
                                     @reloadTypeTaxationTlpe="recherche()"/>
    </b-modal>
    <b-modal v-model="popUpDuplicateTypeTaxationLigne"
             has-modal-card class="modal">
      <pop-up-duplicate-type-taxation-ligne
        :typesTaxeTlpeSelected="getAllTypeTaxationTlpeSelected()"
        @reloadTypeTaxationTlpe="recherche()"/>
    </b-modal>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-type-taxation-tlpe  @toggleFiltre="setShowFiltre"
                ref="filtreTypeTaxationTlpe"
                @recherche="makeRechercheFilter"/>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { TYPE_TAXATION_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import inProgress from '@/services/general/inProgress';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import typeTaxationTlpeLignes from '@/components/parametrage/typeTaxationTlpe/typeTaxationTlpeLignes';
import { ACTION_CREER, ACTION_DUPLIQUER, EXPORT_EXCEL_TYPE_TAXATION_TLPE } from '@/services/parametrage/typeTaxationTlpe/typeTaxationTlpeConf';
import selecteurAction from '@/components/general/selecteurAction';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import popUpCreateTypeTaxationLigne from '@/components/parametrage/typeTaxationTlpe/p_createTypeTaxationLigne';
import popUpDuplicateTypeTaxationLigne from '@/components/parametrage/typeTaxationTlpe/p_duplicateTypeTaxationLigne';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import archiveListButton from '@/components/general/button/archiveListButton';
import { archiver, supprimer } from '@/api/typeTaxationTlpe/';
import validationTypeTaxationTlpe from '@/services/parametrage/validation/validationTypeTaxationTlpe';
import filtreTypeTaxationTlpe from '@/components/parametrage/typeTaxationTlpe/filtreTypeTaxationTlpe';
import deleteListButton from '@/components/general/button/deleteListButton';

const Permissions = createNamespacedHelpers('permissions');
const TypeTaxationTlpe = createNamespacedHelpers('typeTaxationTlpe');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      permsTypeTaxationTlpe: TYPE_TAXATION_TLPE,
      unsubscribeValue: null,
      actions: [
        { action: ACTION_CREER, translation: 'listeTypeTaxationTlpe.actions.create' },
        { action: ACTION_DUPLIQUER, translation: 'listeTypeTaxationTlpe.actions.dupliquer' },
      ],
      popUpCreateTypeTaxationLigne: false,
      popUpDuplicateTypeTaxationLigne: false,
      EXPORT_EXCEL_TYPE_TAXATION_TLPE: EXPORT_EXCEL_TYPE_TAXATION_TLPE,
      showFiltre: false,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    TableItemsInView,
    selecteurAction,
    popUpCreateTypeTaxationLigne,
    popUpDuplicateTypeTaxationLigne,
    exportExcelButton,
    archiveListButton,
    filtreTypeTaxationTlpe,
    deleteListButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...TypeTaxationTlpe.mapGetters({
      typeTaxationTlpe: 'items',
      totalCount: 'totalCount',
      criteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeTypeTaxationTlpe.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeTypeTaxationTlpe.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeTypeTaxationTlpe.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.criteresRecherche.actif !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeTypeTaxationTlpe.tab.libelle'),
          actif: this.$t('listeTypeTaxationTlpe.tab.actif'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        childRow: typeTaxationTlpeLignes,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadTypeTaxationTlpe(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.typeTaxationTlpe,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          actif: 'colonneAction',
        },
        sortable: ['libelle'],
      };
    },
    columns() {
      return ['selected', 'libelle', 'actif', 'edit', 'archiver', 'delete'];
    },
    allTypeTaxationTlpeSelected() {
      return this.getAllTypeTaxationTlpeSelected().length === this.typeTaxationTlpe.length;
    },
    iconSelectTotal() {
      if (this.allTypeTaxationTlpeSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_TYPE_TAXATION_TLPE,
        typeExport: null,
        filtres: generalTransformer(this.lastPayload),
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...TypeTaxationTlpe.mapActions({
      actionsLoadTypeTaxationTlpe: 'loadTypeTaxationTlpe',
    }),
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs.tableTypeTaxationTlpe.refresh();
    },
    goFirstPage() {
      this.$refs.tableTypeTaxationTlpe.setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getAllTypeTaxationTlpeSelected() {
      return this.typeTaxationTlpe.filter((type) => { return type.selected; });
    },
    selectAll() {
      const select = !this.allTypeTaxationTlpeSelected;
      this.typeTaxationTlpe.forEach((el) => { el.selected = select; });
    },
    handleAction(action) {
      switch (action) {
        case ACTION_CREER:
          if (this.checkPermissions(this.permsTypeTaxationTlpe.maj)) {
            this.popUpCreateTypeTaxationLigne = true;
          } else this.showPopUp();
          break;
        default:
          if (this.checkPermissions(this.permsTypeTaxationTlpe.maj)) {
            this.popUpDuplicateTypeTaxationLigne = true;
          } else this.showPopUp();
      }
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreTypeTaxationTlpe.initializeFiltre();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    reinitialiser() {
      this.$refs.filtreTypeTaxationTlpe.initializeFiltre();
      this.$refs.filtreTypeTaxationTlpe.viderCritere();
      this.$refs.filtreTypeTaxationTlpe.appliquerCritere();
      this.showFiltre = false;
    },
    getDataPopupArchivage(typeTaxationTlpe) {
      return {
        title: typeTaxationTlpe.actif
          ? this.$t('listeTypeTaxationTlpe.archivageDesarchiver.archivage')
          : this.$t('listeTypeTaxationTlpe.archivageDesarchiver.desarchivage'),
        messDescription: '',
        successMessage: typeTaxationTlpe.actif
          ? this.$t('listeTypeTaxationTlpe.messages.success.archivage')
          : this.$t('listeTypeTaxationTlpe.messages.success.desarchivage'),
      };
    },
    async archiverTypeTaxationTlpe(typeTaxationTlpe) {
      await archiver({ id: typeTaxationTlpe.id, archiver: typeTaxationTlpe.actif });
      this.recherche();
    },
    validationTypeTaxationTlpeArchivage(response, messagesPopup) {
      validationTypeTaxationTlpe(response, messagesPopup);
    },
    getDataPopupSuppression(typeTaxationTlpe) {
      return {
        messDescription: this.$t('listeTypeTaxationTlpe.suppression.confirmation', { libelle: typeTaxationTlpe.libelle }),
        successMessage: this.$t('listeTypeTaxationTlpe.messages.success.suppression'),
      };
    },
    async supprimerTypeTaxationTlpe(id) {
      await supprimer(id);
      this.recherche();
    },

    validationTypeTaxationTlpeSuppression(response, messagesPopup) {
      validationTypeTaxationTlpe(response, messagesPopup);
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageParametrage.typeTaxationTlpe.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
